import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { Subscription } from 'rxjs';
import { formControlElement, formLabelElement } from 'src/app/animations/animations';
import { SV_USER_ROLE, SV_PROPOSAL_STATUS, SV_USER, PROPOSAL_ID, IFCConcurred, IFCDeclined, IFCPending, ConfirmationHeading, ConfirmationContent, IFCLEGAL, STATUSPendingGovernance, STATUSPendingIFCConcurrence, IFCLegalGroupName, IFCComptrollersGroupName, IFCTaxGroupName, IFCTreasuryGroupName, IFCGovernanceGroupName, IFCSecretaryGroupName, IFCCOMPTROLLERS, IFCTAX, IFCTREASURY, IFCGOVERNANCE, STATUSPendingLocalIFCConcurrence, TAB_TITLE_DEFAULT_CLASS, MemberTypeMapping } from 'src/app/constants/constants';
import { UserDetails } from 'src/app/core/interfaces/User';
import { IFCGroupsDTO, IFCReviewersMembersDTO } from 'src/app/core/interfaces/ifcReviewers';
import { ConfidentialStateService } from 'src/app/core/services/ConfidentialStateService';

import { DataService } from 'src/app/core/services/data_service';

import { DataServiceIFCReviewers } from 'src/app/core/services/data_service_ifc_reviewers';
import { MsGraphService } from 'src/app/core/services/ms-graph';
import { SessionStorageService } from 'src/app/core/services/session_storage';

@Component({
    selector: 'app-ifc-reviewer',
    templateUrl: './ifc-reviewer.component.html',
    styleUrl: './ifc-reviewer.component.less',
    animations: [formControlElement, formLabelElement],
    standalone: false
})
export class IfcReviewerComponent implements OnInit, OnDestroy {
  @Output() ifcPayloadRecords = new EventEmitter<IFCGroupsDTO[]>();
  @Output() isApprovalSubmitted = new EventEmitter<boolean>();
  @Output() isResetEmailTrigger = new EventEmitter<boolean>();
  @Output() isReminderEmailTrigger = new EventEmitter<boolean>();
  @Output() isLoader = new EventEmitter<boolean>();
  @Output() ifcRevewerTabClass = new EventEmitter<string>();
  @Input() isIFCRequired!: boolean;
  @Input() reviewComponent!: boolean | string;


  private confidentialStateSubscription!: Subscription;
  isConfidentialProposal: boolean = false;
  isInitialFormLoaded: boolean = false;

  ifcLegalDefaultMember: IFCReviewersMembersDTO[] = [];
  ifcControllersDefaultMember: IFCReviewersMembersDTO[] = [];
  ifcTaxDefaultMember: IFCReviewersMembersDTO[] = [];
  ifcTreasuryDefaultMember: IFCReviewersMembersDTO[] = [];
  ifcGovernanceDefaultMember: IFCReviewersMembersDTO[] = [];
  ifcSecretaryDefaultMember: IFCReviewersMembersDTO[] = [];
  userRoleTitle: any;
  isDueDate!: string | null;
  isConcurDate!: string;
  legalConcurrence!: string;
  controllersConcurrence!: string;
  taxConcurrence!: string;
  treasuryConcurrence!: string;
  governanceConcurrence!: string;
  proposalStatus!: string;
  loggedInUserID!: number;
  listOfGroupsMemberByDefault: IFCReviewersMembersDTO[] = [];
  approvalsRecords: IFCGroupsDTO[] = [];
  approvalsRecordsFiltered: IFCGroupsDTO[] = [];
  proposal_ID: string = this.session.getItem(PROPOSAL_ID);
  approverId = this.session.getItem(SV_USER).userId;
  isVisible!: boolean;
  isOkLoading!: boolean;
  isModalYesBtnClicked!: boolean;
  isModalNoBtnClicked!: boolean;
  confirmModal?: any;
  confirmationModalHeading = ConfirmationHeading;
  confirmationModalContent = ConfirmationContent;
  showHideModal: boolean = false;
  resetGroupName!: string;
  legalStatus!: boolean | null;
  controllersStatus!: boolean | null;
  taxStatus!: boolean | null;
  treasuryStatus!: boolean | null;
  governanceStatus!: boolean | null;
  ifcLegalApprovalsId!: number | null;
  ifcTaxApprovalsId!: number | null;
  ifcControllersApprovalsId!: number | null;
  ifcTresuryApprovalsId!: number | null;
  ifcGovernanceApprovalsId!: number | null;
  ifcSecretaryApprovalsId!: number | null;
  legalConcuredStatus!: boolean | null;
  controllersConcuredStatus!: boolean | null;
  taxConcuredStatus!: boolean | null;
  treasuryConcuredStatus!: boolean | null;
  governanceConcuredStatus!: boolean | null;
  sessionDueDate: any;
  isActionComplete!: boolean;


  coordianatorIFCForm!: UntypedFormGroup;
  coordianatorIFCFormModel = {
    dueDate: '',
    concurDate: '',
    ifcSecretary: [] as string[],
    ifcLegal: [] as string[],
    ifcControllers: [] as string[],
    ifcTax: [] as string[],
    ifcTreasury: [] as string[],
    ifcGovernance: [] as string[],
  };

  ifcSecretaryForm!: UntypedFormGroup;
  ifcSecretaryFormModel = {
    dueDate: '',
    concurDate: '',
    ifcSecretary: '',
  };
  ifcLegalForm!: UntypedFormGroup;
  ifcLegalFormModel = {
    ifcLegal: '',
    legalComments: '',
    ifcLegalSwitch: false,
  };
  ifcControllersForm!: UntypedFormGroup;
  ifcControllersFormModel = {
    ifcControllers: '',
    controllersComments: '',
    ifcControllersSwitch: false,
  };
  ifcTaxForm!: UntypedFormGroup;
  ifcTaxFormModel = {
    ifcTax: '',
    taxComments: '',
    ifcTaxSwitch: false,
  };
  ifcTreasuryForm!: UntypedFormGroup;
  ifcTreasuryFormModel = {
    ifcTreasury: '',
    treasuryComments: '',
    ifcTreasurySwitch: false,
  };
  ifcGovernanceForm!: UntypedFormGroup;
  ifcGovernanceFormModel = {
    ifcGovernance: '',
    governanceComments: '',
    ifcGovernanceSwitch: false,
  };
  currentUserEmail: any;

  constructor(
    private fb: UntypedFormBuilder,
    private dataservice: DataService,
    private session: SessionStorageService,
    private graph: MsGraphService,
    private ifcReviewersService: DataServiceIFCReviewers,
    private confidentialStateService: ConfidentialStateService
  ) { }


  async ngOnInit() {
    this.isActionComplete = false;
    this.loggedInUserID = this.session.getItem(SV_USER).userId;
    this.currentUserEmail = this.session.getItem(SV_USER).emailAddress;
    this.dataservice.getUserRoleTitle(this.session.getItem(SV_USER_ROLE).roleTitle);
    this.proposalStatus = this.session.getItem(SV_PROPOSAL_STATUS).name.toLocaleLowerCase();
    this.userRoleTitle = this.dataservice.roleTitle.toLocaleLowerCase();
    this.sessionDueDate = null;//this.session.getItem("duedate") ? this.session.getItem("duedate") : null;
    this.ifcReviewersService.reviewNsubmitStatus(undefined);
    this.ifcReviewersService.getIFCUpdateRecordsStatus(undefined);

    // Subscribe to confidential state changes
    this.confidentialStateSubscription = this.confidentialStateService.isConfidential$.subscribe({
      next: (isConfidential: boolean) => {
        this.isConfidentialProposal = isConfidential;
        this.setupFormControls();
      },
      error: (error) => {
        console.error('IFC Reviewer: Subscription error:', error);
      },
      complete: () => {
        console.log('IFC Reviewer: Subscription completed');
      }
    });
    // Get initial state from session if available
    // Get current state from service (this will NOT trigger subscription yet since forms aren't ready)
    const currentServiceState = this.confidentialStateService.getCurrentState();
    const sessionConfidential = this.session.getItem('isConfidentialProposal');

    // Determine the state to use but don't set it yet
    let stateToUse = false;
    if (currentServiceState !== false) {
      stateToUse = currentServiceState;
    } else if (sessionConfidential !== null) {
      stateToUse = sessionConfidential === 'true' || sessionConfidential === true;
    }

    this.isConfidentialProposal = stateToUse;

    if (this.isIFCRequired) {
      this.createFormGroupsWithNestedFormControllers();      
      await this.getDefaultMemberOfGroups();
      await this.getApprovalsList();
      this.enableDisableCommentsFormFields();
      this.selectDueByDate(this.ifcSecretaryFormModel.dueDate);

      // NOW set the state after forms are initialized - this will trigger the subscription
      this.confidentialStateService.setConfidentialState(stateToUse);  
      this.isInitialFormLoaded = true;    
    }
  }

  async setupFormControls() {
    if(!this.isInitialFormLoaded) return;
    await this.clearIFCFormControls();

    if (this.isConfidentialProposal) {
      // When confidential, enable manual selection of IFC reviewers
      await this.getApprovalsList(true);
    } else {
      // When not confidential, use default values and make readonly
      await this.getDefaultMemberOfGroups();
    }
  }
  async clearIFCFormControls() {
    this.coordianatorIFCForm?.controls['ifcLegal']?.setValue(null);
    this.coordianatorIFCForm?.controls['ifcControllers']?.setValue(null);
    this.coordianatorIFCForm?.controls['ifcTax']?.setValue(null);
    this.coordianatorIFCForm?.controls['ifcTreasury']?.setValue(null);
    this.coordianatorIFCForm?.controls['ifcGovernance']?.setValue(null);
    this.coordianatorIFCForm?.controls['ifcSecretary']?.setValue(null);

    this.coordianatorIFCFormModel.ifcLegal = [];
    this.coordianatorIFCFormModel.ifcControllers = [];    
    this.coordianatorIFCFormModel.ifcTax = [];
    this.coordianatorIFCFormModel.ifcTreasury = [];
    this.coordianatorIFCFormModel.ifcGovernance = [];
    this.coordianatorIFCFormModel.ifcSecretary = [];
    
  }

  // to get default members of all groups
  async getDefaultMemberOfGroups() {
    
    this.isLoader.emit(true);
    this.listOfGroupsMemberByDefault = [];
    let defaultUser = await this.ifcReviewersService.defaultGroupMemberAPICall();
    defaultUser.subscribe({
      next: (groupMember) => {
        if (groupMember['body']) {
          this.listOfGroupsMemberByDefault = [...groupMember['body']];
          this.storeDefaultMemberIntoVariable();
          this.isLoader.emit(false);          
        }
      },
      error: (err) => {
        console.log("default members error => ", err);
      },
      complete: () => {
        this.isLoader.emit(false);
      }
    })
  }

  // to get all records of approval
  async getApprovalsList(isForceRefresh: boolean = false) {    
    this.isLoader.emit(true);
    let approvalsRecords = await this.ifcReviewersService.getIFCApprovals();
    approvalsRecords.subscribe({
      next: (approvals) => {
        let ifcApprovals: IFCGroupsDTO[] = [];
        ifcApprovals = approvals['body'];
        ifcApprovals = ifcApprovals?.filter(x => (x.type.toString().toLocaleLowerCase() == IFCComptrollersGroupName 
                                               || x.type.toString().toLocaleLowerCase() == IFCGovernanceGroupName 
                                               || x.type.toString().toLocaleLowerCase() == IFCTreasuryGroupName 
                                               || x.type.toString().toLocaleLowerCase() == IFCLegalGroupName 
                                               || x.type.toString().toLocaleLowerCase() == IFCTaxGroupName
                                               || x.type.toString().toLocaleLowerCase() == IFCSecretaryGroupName));
        approvals = ifcApprovals;
        if (ifcApprovals && ifcApprovals.length>0) {
          this.isLoader.emit(false);
          //this.setDefaultSecretary(); NOT REQUIRED - Handled in setPendingGoverenceFormValues() by Manas
          this.reviewComponentUIShowHideData(ifcApprovals);

          if (ifcApprovals[0].dueDate) {
            this.isApprovalSubmitted.emit(true);
            this.ifcReviewersService.getIFCUpdateRecordsStatus(true);
            this.isDueDate = ifcApprovals[0].dueDate;
            this.ifcSecretaryForm?.controls['dueDate'].setValue(ifcApprovals[0]?.dueDate);
            this.ifcSecretaryForm?.updateValueAndValidity();
            this.isActionComplete = true;
            this.ifcRevewerTabClass.emit(TAB_TITLE_DEFAULT_CLASS);
          }
          for (let approval of ifcApprovals) {
            this.setUpdateIFCFormFieldsValue(approval, isForceRefresh);
          }          
          this.applyConfidentialGovernanceRule();
          this.setResetDueDateFormValidation();
        } else {
          this.isActionComplete = true;
          this.isDueDate = null;
          this.isApprovalSubmitted.emit(false);
          this.ifcReviewersService.getIFCUpdateRecordsStatus(false);
          this.storeDefaultMemberIntoVariable();
          this.setResetDueDateFormValidation();
        }
      },
      error: (err) => {
        console.log("approvals records error => ", err);
      },
      complete: () => {
        this.isLoader.emit(false);
      }
    })
  }

  // to set default secretary group member
  setDefaultSecretary() {
    let defaultSecretary = this.listOfGroupsMemberByDefault.find((ele: any) => {
      return ele['type'].toLocaleLowerCase() == IFCSecretaryGroupName;
    })
    switch (this.proposalStatus) {
      case STATUSPendingGovernance: {
        this.coordianatorIFCForm?.controls['ifcSecretary'].setValue(defaultSecretary?.defaultEmail);
        this.coordianatorIFCFormModel.ifcTreasury = <any>defaultSecretary?.defaultEmail;
        break;
      }
      case STATUSPendingIFCConcurrence: {
        this.ifcSecretaryForm?.controls['ifcSecretary'].setValue(defaultSecretary?.defaultEmail);
        this.ifcSecretaryFormModel.ifcSecretary = <any>defaultSecretary?.defaultEmail;
        break;
      }
      case 'default': {
        break;
      }
    }
  }

  setUpdateIFCFormFieldsValue(approvalRecords: IFCGroupsDTO, isForceRefresh: boolean = false) {
    if (this.proposalStatus == STATUSPendingGovernance) {
      this.setPendingGoverenceFormValues(approvalRecords, isForceRefresh);
    } else if (this.proposalStatus == STATUSPendingIFCConcurrence || this.proposalStatus == STATUSPendingLocalIFCConcurrence) {
      this.setIFCConcurrenceFormValues(approvalRecords);
    }
  }
  setControlDirty(controlName: string) {
    const control = this.coordianatorIFCForm?.controls[controlName];
    control?.markAsDirty();
    control?.updateValueAndValidity({ onlySelf: true });
  }
  setPendingGoverenceFormValuesForLegal(approvalRecords: IFCGroupsDTO, approverEmailArr: string[], isForceRefresh: boolean = false) {
    this.ifcLegalDefaultMember = [];
    approverEmailArr.forEach((email, index) => {
      if (email != '') {
        this.ifcLegalDefaultMember.push({
          defaultEmail: email,
          reviewerId: 1,
          type: approvalRecords.type,
        });
      }
    });
    this.coordianatorIFCForm?.controls['ifcLegal'].setValue(approverEmailArr);          
    this.coordianatorIFCFormModel.ifcLegal = approverEmailArr;
    this.ifcLegalApprovalsId = <any>approvalRecords['approvalsId'];
    this.setControlDirty('ifcLegal');
  }
  setPendingGoverenceFormValuesForIFCComptrollers(approvalRecords: IFCGroupsDTO, approverEmailArr: string[], isForceRefresh: boolean = false) {
    this.ifcControllersDefaultMember = [];    
    approverEmailArr.forEach((email, index) => {
      if (email != '') {
        this.ifcControllersDefaultMember.push({
          defaultEmail: email,
          reviewerId: 2,
          type: approvalRecords.type,
        });
      }
    });
    this.coordianatorIFCForm?.controls['ifcControllers'].setValue(approverEmailArr);
    this.coordianatorIFCFormModel.ifcControllers = approverEmailArr;
    this.ifcControllersApprovalsId = <any>approvalRecords['approvalsId'];
    this.setControlDirty('ifcControllers');
  }
  setPendingGoverenceFormValues(approvalRecords: IFCGroupsDTO, isForceRefresh: boolean = false) {
    const due = this.sessionDueDate ? this.sessionDueDate : null;
    const dueDate = this.isDueDate ? this.isDueDate : due;
    if (this.proposalStatus == STATUSPendingGovernance) {
      this.coordianatorIFCForm?.controls['dueDate'].setValue(dueDate);
      this.coordianatorIFCFormModel.dueDate = dueDate;
      this.coordianatorIFCForm?.controls['concurDate'].setValue(this.isConcurDate);
      this.coordianatorIFCFormModel.concurDate = this.isConcurDate;
      var dbApproverEmail = isForceRefresh ? '' : approvalRecords['approverEmail'];
      var approverEmail = this.isConfidentialProposal ?  dbApproverEmail : this.getDefaultIFCMember(approvalRecords.type).defaultEmail; 
      // Filter out empty strings after splitting
      let approverEmailArr = approverEmail.includes(';') 
      ? approverEmail.split(';').filter(email => email.length>3) 
      : [approverEmail].filter(email => email.length>3);
      
      switch (approvalRecords.type.toLocaleLowerCase()) {
        case IFCLegalGroupName: {
          this.setPendingGoverenceFormValuesForLegal(approvalRecords, approverEmailArr, isForceRefresh);
          break;
        }
        case IFCComptrollersGroupName: {
          this.setPendingGoverenceFormValuesForIFCComptrollers(approvalRecords, approverEmailArr, isForceRefresh);
          break;
        }
        case IFCTaxGroupName: {
          this.ifcTaxDefaultMember = [];
          approverEmailArr.forEach((email, index) => {
            if (email != '') {
              this.ifcTaxDefaultMember.push({
                defaultEmail: email,
                reviewerId: 3,
                type: approvalRecords.type,
              });
            }
          });
          this.coordianatorIFCForm?.controls['ifcTax'].setValue(approverEmailArr);
          this.setControlDirty('ifcTax');
          this.coordianatorIFCFormModel.ifcTax = approverEmailArr;
          this.ifcTaxApprovalsId = <any>approvalRecords['approvalsId'];
          break;
        }
        case IFCTreasuryGroupName: {
          this.ifcTreasuryDefaultMember = [];
          approverEmailArr.forEach((email, index) => {
            if (email != '') {
              this.ifcTreasuryDefaultMember.push({
                defaultEmail: email,
                reviewerId: 4,
                type: approvalRecords.type,
              });
            }
          });
          this.coordianatorIFCForm?.controls['ifcTreasury'].setValue(approverEmailArr);
          this.setControlDirty('ifcTreasury');
          this.coordianatorIFCFormModel.ifcTreasury = approverEmailArr;
          this.ifcTresuryApprovalsId = <any>approvalRecords['approvalsId'];
          break;
        }
        case IFCGovernanceGroupName: {
          this.ifcGovernanceDefaultMember = [];
          approverEmailArr.forEach((email, index) => {
            if (email != '') {
              this.ifcGovernanceDefaultMember.push({
                defaultEmail: email,
                reviewerId: 5,
                type: approvalRecords.type,
              });
            }
          });
          this.coordianatorIFCForm?.controls['ifcGovernance'].setValue(approverEmailArr);
          this.setControlDirty('ifcGovernance');
          this.coordianatorIFCFormModel.ifcGovernance = approverEmailArr;          
          this.ifcGovernanceApprovalsId = <any>approvalRecords['approvalsId'];
          break;
        }
        case IFCSecretaryGroupName: {
          this.ifcSecretaryDefaultMember = [];
          approverEmailArr.forEach((email, index) => {
            if (email != '') {
              this.ifcSecretaryDefaultMember.push({
                defaultEmail: email,
                reviewerId: 6,
                type: approvalRecords.type,
              });
            } 
          });
          this.coordianatorIFCForm?.controls['ifcSecretary']?.setValue(approverEmailArr);
          this.setControlDirty('ifcSecretary');
          this.coordianatorIFCFormModel.ifcSecretary = structuredClone(approverEmailArr);
          this.ifcSecretaryApprovalsId = <any>approvalRecords['approvalsId'];
          break;
        }
        case 'default': {
          break;
        }
      }
      this.coordianatorIFCForm?.updateValueAndValidity();
    }
  }

  setIFCConcurrenceFormValues(approvalRecords: IFCGroupsDTO) {
    let status = approvalRecords['status'] === false ? IFCDeclined : IFCPending;
    switch (approvalRecords.type.toLocaleLowerCase()) {
      case IFCLegalGroupName: {
        this.ifcLegalDefaultMember = [];
        this.ifcLegalForm?.setValue({
          ifcLegal: approvalRecords['approverEmail'],
          legalComments: approvalRecords['comment'],
          ifcLegalSwitch: approvalRecords['reset'],
        });
        this.ifcLegalForm?.updateValueAndValidity();
        this.ifcLegalDefaultMember.push({
          defaultEmail: approvalRecords['approverEmail'],
          reviewerId: approvalRecords['reviewerId'],
          type: approvalRecords['type'],
        });
        this.ifcLegalApprovalsId = <any>approvalRecords['approvalsId'];
        this.ifcLegalFormModel.ifcLegal = approvalRecords['approverEmail'];
        this.ifcLegalFormModel.legalComments = approvalRecords['comment'];
        this.ifcLegalFormModel.ifcLegalSwitch = <any>approvalRecords['reset'];
        this.legalConcuredStatus = approvalRecords['status'];
        this.legalConcurrence = approvalRecords['status'] === true ? IFCConcurred : status;
        if (this.legalConcurrence !== IFCConcurred) this.ifcLegalForm?.controls['ifcLegalSwitch'].disable();
        break;
      }
      case IFCComptrollersGroupName: {
        this.ifcControllersDefaultMember = [];
        this.ifcControllersForm.setValue({
          ifcControllers: approvalRecords['approverEmail'],
          controllersComments: approvalRecords['comment'],
          ifcControllersSwitch: approvalRecords['reset'],
        });
        this.ifcControllersForm?.updateValueAndValidity();
        this.ifcControllersDefaultMember.push({
          defaultEmail: approvalRecords['approverEmail'],
          reviewerId: approvalRecords['reviewerId'],
          type: approvalRecords['type'],
        });
        this.ifcControllersApprovalsId = <any>approvalRecords['approvalsId'];
        this.ifcControllersFormModel.ifcControllers = approvalRecords['approverEmail'];
        this.controllersConcuredStatus = approvalRecords['status'];
        this.controllersConcurrence = approvalRecords['status'] === true ? IFCConcurred : status;
        if (this.controllersConcurrence !== IFCConcurred) this.ifcControllersForm?.controls['ifcControllersSwitch'].disable();
        break;
      }
      case IFCTaxGroupName: {
        this.ifcTaxDefaultMember = [];
        this.ifcTaxForm.setValue({
          ifcTax: approvalRecords['approverEmail'],
          taxComments: approvalRecords['comment'],
          ifcTaxSwitch: approvalRecords['reset'],
        });
        this.ifcTaxForm?.updateValueAndValidity();
        this.ifcTaxDefaultMember.push({
          defaultEmail: approvalRecords['approverEmail'],
          reviewerId: approvalRecords['reviewerId'],
          type: approvalRecords['type'],
        });
        this.ifcTaxApprovalsId = <any>approvalRecords['approvalsId'];
        this.ifcTaxFormModel.ifcTax = approvalRecords['approverEmail'];
        this.taxConcuredStatus = approvalRecords['status'];
        this.taxConcurrence = approvalRecords['status'] === true ? IFCConcurred : status;
        if (this.taxConcurrence !== IFCConcurred) this.ifcTaxForm?.controls['ifcTaxSwitch'].disable();
        break;
      }
      case IFCTreasuryGroupName: {
        this.ifcTreasuryDefaultMember = []
        this.ifcTreasuryForm.setValue({
          ifcTreasury: approvalRecords['approverEmail'],
          treasuryComments: approvalRecords['comment'],
          ifcTreasurySwitch: approvalRecords['reset'],
        });
        this.ifcTreasuryForm?.updateValueAndValidity();
        this.ifcTreasuryDefaultMember.push({
          defaultEmail: approvalRecords['approverEmail'],
          reviewerId: approvalRecords['reviewerId'],
          type: approvalRecords['type'],
        });
        this.ifcTresuryApprovalsId = <any>approvalRecords['approvalsId'];
        this.ifcTreasuryFormModel.ifcTreasury = approvalRecords['approverEmail'];
        this.treasuryConcuredStatus = approvalRecords['status'];
        this.treasuryConcurrence = approvalRecords['status'] === true ? IFCConcurred : status;
        if (this.treasuryConcurrence !== IFCConcurred) this.ifcTreasuryForm?.controls['ifcTreasurySwitch'].disable();
        break;
      }
      case IFCGovernanceGroupName: {
        this.ifcGovernanceDefaultMember = [];
        this.ifcGovernanceForm?.controls['ifcGovernance'].setValue(approvalRecords['approverEmail']);
        this.ifcGovernanceForm?.controls['governanceComments'].setValue(approvalRecords['comment']);
        this.ifcGovernanceForm?.controls['ifcGovernanceSwitch'].setValue(approvalRecords['reset']);
        this.ifcGovernanceFormModel.governanceComments = approvalRecords['comment'];
        this.ifcGovernanceForm?.updateValueAndValidity();
        this.ifcGovernanceDefaultMember.push({
          defaultEmail: approvalRecords['approverEmail'],
          reviewerId: approvalRecords['reviewerId'],
          type: approvalRecords['type'],
        });
        this.ifcGovernanceApprovalsId = <any>approvalRecords['approvalsId'];
        this.governanceConcuredStatus = approvalRecords['status'];
        this.governanceConcurrence = approvalRecords['status'] === true ? IFCConcurred : status;
        if (this.governanceConcurrence !== IFCConcurred) this.ifcGovernanceForm?.controls['ifcGovernanceSwitch'].disable();
        break;
      }
      case IFCSecretaryGroupName: {
        this.ifcSecretaryForm.setValue({
          dueDate: approvalRecords['dueDate'],
          concurDate: approvalRecords['concurDate'],
          ifcSecretary: approvalRecords['approverEmail'],
        });
        break;
      }
    }
  }

  enableDisableCommentsFormFields() {
    if ((this.proposalStatus == STATUSPendingIFCConcurrence) || (this.proposalStatus == STATUSPendingLocalIFCConcurrence)) {
      this.ifcLegalForm.controls['legalComments'].disable();
      this.ifcLegalForm.controls['ifcLegal'].disable();
      this.ifcControllersForm.controls['controllersComments'].disable();
      this.ifcControllersForm.controls['ifcControllers'].disable();
      this.ifcTaxForm.controls['taxComments'].disable();
      this.ifcTaxForm.controls['ifcTax'].disable();
      this.ifcTreasuryForm.controls['treasuryComments'].disable();
      this.ifcTreasuryForm.controls['ifcTreasury'].disable();
      this.ifcGovernanceForm.controls['governanceComments'].disable();
      this.ifcGovernanceForm.controls['ifcGovernance'].disable();
      this.ifcSecretaryForm.controls['ifcSecretary'].disable();
    }
  }

  createFormGroupsWithNestedFormControllers() {
    if (this.proposalStatus == 'pending ifc concurrence' || this.proposalStatus == 'pending reviewer(s) concurrence') {
      this.ifcSecretaryForm = this.fb.group({
        dueDate: [null],
        concurDate: [null],
        ifcSecretary: [null],
      });
      this.ifcLegalForm = this.fb.group({
        ifcLegal: [null],
        legalComments: [null],
        ifcLegalSwitch: [false],
      });
      this.ifcControllersForm = this.fb.group({
        ifcControllers: [null],
        controllersComments: [null],
        ifcControllersSwitch: [false],
      });
      this.ifcTaxForm = this.fb.group({
        ifcTax: [null],
        taxComments: [null],
        ifcTaxSwitch: [false],
      });
      this.ifcTreasuryForm = this.fb.group({
        ifcTreasury: [null],
        treasuryComments: [null],
        ifcTreasurySwitch: [false],
      });
      this.ifcGovernanceForm = this.fb.group({
        ifcGovernance: [null],
        governanceComments: [null],
        ifcGovernanceSwitch: [false],
      });
    } else {
      this.coordianatorIFCForm = this.fb.group({
        dueDate: [null],
        concurDate: [null],
        ifcSecretary: [null, Validators.required],
        ifcLegal: [null, Validators.required],
        ifcControllers: [null, Validators.required],
        ifcTax: [null, Validators.required],
        ifcTreasury: [null, Validators.required],
        ifcGovernance: [null, Validators.required],
      });
    }
  }
  
  getDefaultIFCMember(memberType: string) : IFCReviewersMembersDTO {
    let defaultMember = this.listOfGroupsMemberByDefault.find((ele: any) => {
      return ele['type'].toLocaleLowerCase() == memberType.toLocaleLowerCase();
    });
    return defaultMember ? defaultMember : { defaultEmail: '', reviewerId: 0, type: memberType };
  }

  async storeDefaultMemberIntoVariable() {
    const dueDate = this.isDueDate ? this.isDueDate : this.sessionDueDate;
    this.coordianatorIFCForm?.controls['dueDate'].setValue(dueDate);
    if (!this.listOfGroupsMemberByDefault) {
      return;
    }
    // Define mapping for member types to their corresponding properties 
    this.listOfGroupsMemberByDefault.forEach((member: IFCReviewersMembersDTO) => {
      const memberTypeLower = member.type.toLowerCase();
      const mapping = MemberTypeMapping[memberTypeLower];

      if (!mapping) {
        return; // Skip if mapping not found
      }

      const defaultConfiguredEmail = this.isConfidentialProposal ? '' : member.defaultEmail;

      // Reset the default member array
      (this as any)[mapping.defaultMemberArray] = [];
      if (this.isConfidentialProposal)
        return; // Skip adding default members if confidential
      // Push new member data
      (this as any)[mapping.defaultMemberArray].push({
        defaultEmail: defaultConfiguredEmail,
        reviewerId: member.reviewerId,
        type: member.type,
      });

      // Set coordinator form control and model
      this.coordianatorIFCForm?.controls[mapping.formControl]?.setValue([defaultConfiguredEmail]);
      (this.coordianatorIFCFormModel as any)[mapping.formModel] = [defaultConfiguredEmail];

    });
    this.applyConfidentialGovernanceRule();
  }

  setResetDueDateFormValidation() {
    switch (this.proposalStatus) {
      case STATUSPendingGovernance: {
        const controls = this.coordianatorIFCForm?.controls["dueDate"];
        if (this.isDueDate) {
          controls.removeValidators([Validators.required]);
          controls?.updateValueAndValidity();
        } else {
          controls.setValidators([Validators.required]);
          controls?.updateValueAndValidity({ onlySelf: true });
        }
        break;
      }
      case STATUSPendingIFCConcurrence: {
        const cocurrenceDueDateControl = this.ifcSecretaryForm?.controls["dueDate"];
        if (this.isDueDate) {
          cocurrenceDueDateControl.removeValidators([Validators.required]);
          cocurrenceDueDateControl?.updateValueAndValidity();
        } else {
          cocurrenceDueDateControl.setValidators([Validators.required]);
          cocurrenceDueDateControl?.updateValueAndValidity({ onlySelf: true });
        }
        break;
      }
    }
  }

  // to get confirmation from modal
  getConfirmation(action: string) {
    this.setResetToggleValue(action);
    this.showHideModal = false;
  }

  // toggle btn to reset the group members
  resetApprovalToggle(event: any, groupName: string) {
    if (event) {
      this.resetGroupName = groupName;
      this.showHideModal = true;
      this.updateIFCMemberResetValue(groupName, true);
    }
  }

  updateIFCMemberResetValue(group: string, resetAction: boolean) {
    switch (group) {
      case 'legal': {
        this.ifcLegalForm?.controls['ifcLegalSwitch'].setValue(resetAction);
        this.ifcLegalForm?.controls['ifcLegalSwitch'].disable();
        break;
      }
      case 'controllers': {
        this.ifcControllersForm?.controls['ifcControllersSwitch'].setValue(resetAction);
        this.ifcControllersForm.controls['ifcControllersSwitch'].disable();
        break;
      }
      case 'tax': {
        this.ifcTaxForm?.controls['ifcTaxSwitch'].setValue(resetAction);
        this.ifcTaxForm?.controls['ifcTaxSwitch'].disable();
        break;
      }
      case 'treasury': {
        this.ifcTreasuryForm?.controls['ifcTreasurySwitch'].setValue(resetAction);
        this.ifcTreasuryForm?.controls['ifcTreasurySwitch'].disable();
        break;
      }
      case 'governance': {
        this.ifcGovernanceForm?.controls['ifcGovernanceSwitch'].setValue(resetAction);
        this.ifcGovernanceForm?.controls['ifcGovernanceSwitch'].disable();
        break;
      }
    }
  }

  // based upon modal action status set values into forms fields.
  setResetToggleValue(action: string) {
    this.showHideModal = false;
    if (action == 'yes') {
      this.isResetEmailTrigger.emit(true);
      this.createPayload();
      switch (this.resetGroupName) {
        case 'legal': {
          this.legalConcurrence = '';
          this.ifcLegalForm?.controls['ifcLegal'].enable();
          this.ifcReviewersService.updateIFCApproval(IFCLEGAL);
          break;
        }
        case 'controllers': {
          this.controllersConcurrence = '';
          this.ifcControllersForm?.controls['ifcControllers'].enable();
          this.ifcReviewersService.updateIFCApproval(IFCCOMPTROLLERS);
          break;
        }
        case 'tax': {
          this.taxConcurrence = '';
          this.ifcTaxForm?.controls['ifcTax'].enable();
          this.ifcReviewersService.updateIFCApproval(IFCTAX);
          break;
        }
        case 'treasury': {
          this.treasuryConcurrence = '';
          this.ifcTreasuryForm?.controls['ifcTreasury'].enable();
          this.ifcReviewersService.updateIFCApproval(IFCTREASURY);
          break;
        }
        case 'governance': {
          this.governanceConcurrence = '';
          this.ifcGovernanceForm?.controls['ifcGovernance'].enable();
          this.ifcReviewersService.updateIFCApproval(IFCGOVERNANCE);
          break;
        }
        default: {
          break;
        }
      }
    } else {
      this.getApprovalsList();
      this.enableDisableGroupMemeberField();
    }


  }

  enableDisableGroupMemeberField() {
    switch (this.resetGroupName) {
      case 'legal': {
        this.ifcLegalForm?.controls['ifcLegal'].disable();
        break;
      }
      case 'controllers': {
        this.ifcControllersForm?.controls['ifcControllers'].disable();
        break;
      }
      case 'tax': {
        this.ifcTaxForm?.controls['ifcTax'].disable();
        break;
      }
      case 'treasury': {
        this.ifcTreasuryForm?.controls['ifcTreasury'].disable();
        break;
      }
      case 'governance': {
        this.ifcGovernanceForm?.controls['ifcGovernance'].disable();
        break;
      }
    }
  }

  selectDueByDate(event: any) {
    console.log("Selected Due Date => ", event);
    if (!event) {
      this.ifcReviewersService.getIFCUpdateRecordsStatus(undefined);
      console.log("Due Date cleared");
      this.isDueDate = null;
      this.session.setItem("duedate", null);
      // this.isActionComplete = true;
      this.isApprovalSubmitted.emit(false);
      this.createPayload();
      this.setResetDueDateFormValidation();
    } else {
      console.log("Due Date selected");
      let dueDate = new Date(event).toLocaleString('en-US');
      this.session.setItem("duedate", dueDate);
      this.setResetDueDateFormValidation();
      let isNewDateSelected = this.compareDueDateAndSelectedDate(event);
      if (this.isActionComplete || isNewDateSelected) {
        if (this.isDueDate) {
          this.ifcReviewersService.getIFCUpdateRecordsStatus(true);
          this.isApprovalSubmitted.emit(true);
          this.isDueDate = dueDate;
          this.isActionComplete = false;
          this.createPayload();
        } else {
          this.ifcReviewersService.getIFCUpdateRecordsStatus(false);
          this.isApprovalSubmitted.emit(false);
          this.isDueDate = dueDate;
          this.isActionComplete = false;
          this.createPayload();
        }
      }
    }
  }

  compareDueDateAndSelectedDate(event: any) {
    if (this.isDueDate == event) {
      this.ifcReviewersService.reviewNsubmitStatus(undefined);
      this.ifcReviewersService.getIFCUpdateRecordsStatus(undefined);
      return false;
    } else {
      this.ifcReviewersService.reviewNsubmitStatus(true);
      return true;
    }
  }

  selectConcurByDate(event: any) {
    if (event) {
      this.isConcurDate = event;
    }
  }

  legalPayload() {
    const dueDate = this.isDueDate ? this.isDueDate : this.sessionDueDate; 
    const legalPayload = [
      {
        reviewerId: this.ifcLegalDefaultMember[0]?.reviewerId,
        type: this.ifcLegalDefaultMember[0]?.type,
        approvalsId: Number(this.ifcLegalApprovalsId),
        approverId: null,
        approverEmail: this.getApproverEmails('ifcLegal', this.proposalStatus),
        dueDate: dueDate,
        concurDate: this.isConcurDate ? this.isConcurDate : null,
        status: this.proposalStatus === STATUSPendingGovernance ? null : this.legalConcuredStatus,
        comment: this.proposalStatus === STATUSPendingGovernance ? '' : this.ifcLegalForm?.controls['legalComments'].value,
        reset: this.proposalStatus === STATUSPendingGovernance ? null : this.ifcLegalForm?.controls['ifcLegalSwitch'].value,
      }
    ]
    return legalPayload;
  }
  getApproverEmails(controlName: string, proposalStatus: string): string {
    const formValue = proposalStatus === STATUSPendingGovernance ?
      this.coordianatorIFCForm?.controls[controlName].value?.join(";") :
      this.ifcLegalForm?.controls[controlName].value?.join(";");
      return formValue;
    
  }
  createPayload() {
    if(!this.ifcLegalDefaultMember[0] || !this.ifcControllersDefaultMember[0] || !this.ifcTaxDefaultMember[0] ||
      !this.ifcTreasuryDefaultMember[0] || !this.ifcGovernanceDefaultMember[0] || !this.ifcSecretaryDefaultMember[0]){
        
        return;
      }
    const dueDate = this.isDueDate ;//? this.isDueDate : this.sessionDueDate;
    let legalPayload: IFCGroupsDTO[] = this.legalPayload();    
    // Construct the full payload array
    let payload: IFCGroupsDTO[] = [...legalPayload,
    {
      reviewerId: this.ifcControllersDefaultMember[0]?.reviewerId,
      type: this.ifcControllersDefaultMember[0]?.type,
      approverId: null,
      approvalsId: Number(this.ifcControllersApprovalsId),
      approverEmail: this.getApproverEmails('ifcControllers', this.proposalStatus),
      dueDate: dueDate,
      concurDate: this.isConcurDate ? this.isConcurDate : null,
      status: this.proposalStatus == STATUSPendingGovernance ? null : this.controllersConcuredStatus,
      comment: this.proposalStatus == STATUSPendingGovernance ? '' : this.ifcControllersForm?.controls['controllersComments'].value,
      reset: this.proposalStatus == STATUSPendingGovernance ? null : this.ifcControllersForm?.controls['ifcControllersSwitch'].value,
    },
    {
      reviewerId: this.ifcTaxDefaultMember[0].reviewerId,
      type: this.ifcTaxDefaultMember[0].type,
      approverId: null,
      approvalsId: Number(this.ifcTaxApprovalsId),
      approverEmail: this.getApproverEmails('ifcTax', this.proposalStatus),
      dueDate: dueDate,
      concurDate: this.isConcurDate ? this.isConcurDate : null,
      status: this.proposalStatus == STATUSPendingGovernance ? null : this.taxConcuredStatus,
      comment: this.proposalStatus == STATUSPendingGovernance ? '' : this.ifcTaxForm?.controls['taxComments'].value,
      reset: this.proposalStatus == STATUSPendingGovernance ? null : this.ifcTaxForm?.controls['ifcTaxSwitch'].value,
    },
    {
      reviewerId: this.ifcTreasuryDefaultMember[0]?.reviewerId,
      type: this.ifcTreasuryDefaultMember[0]?.type,
      approverId: null,
      approvalsId: Number(this.ifcTresuryApprovalsId),
      approverEmail: this.getApproverEmails('ifcTreasury', this.proposalStatus),
      dueDate: dueDate,
      concurDate: this.isConcurDate ? this.isConcurDate : null,
      status: this.proposalStatus == STATUSPendingGovernance ? null : this.treasuryConcuredStatus,
      comment: this.proposalStatus == STATUSPendingGovernance ? '' : this.ifcTreasuryForm?.controls['treasuryComments'].value,
      reset: this.proposalStatus == STATUSPendingGovernance ? null : this.ifcTreasuryForm?.controls['ifcTreasurySwitch'].value,
    },
    {
      reviewerId: this.ifcGovernanceDefaultMember[0].reviewerId,
      type: this.ifcGovernanceDefaultMember[0].type,
      approverId: null,
      approvalsId: Number(this.ifcGovernanceApprovalsId),
      approverEmail: this.getApproverEmails('ifcGovernance', this.proposalStatus),
      dueDate: dueDate,
      concurDate: this.isConcurDate ? this.isConcurDate : null,
      status: this.proposalStatus == STATUSPendingGovernance ? null : this.governanceConcuredStatus,
      comment: this.proposalStatus == STATUSPendingGovernance ? '' : this.ifcGovernanceForm?.controls['governanceComments'].value,
      reset: this.proposalStatus == STATUSPendingGovernance ? null : this.ifcGovernanceForm?.controls['ifcGovernanceSwitch'].value,
    },
    {
      reviewerId: this.ifcSecretaryDefaultMember[0].reviewerId,
      type: this.ifcSecretaryDefaultMember[0].type,
      approverId: null,
      approvalsId: Number(this.ifcSecretaryApprovalsId),
      approverEmail: this.getApproverEmails('ifcSecretary', this.proposalStatus),
      dueDate: dueDate,
      concurDate: this.isConcurDate ? this.isConcurDate : null,
      status: this.proposalStatus == STATUSPendingGovernance ? null : null, //this.secretaryConcuredStatus, TBD_MANAS
      comment: this.proposalStatus == STATUSPendingGovernance ? '' : this.ifcSecretaryForm?.controls['secretaryComments'].value,
      reset: this.proposalStatus == STATUSPendingGovernance ? null : this.ifcSecretaryForm?.controls['ifcSecretarySwitch'].value,
    }
    ];
    // Filter out entries with null or empty approverEmail
    payload = payload.filter(x => x.approverEmail != null && x.approverEmail != '');    
    this.ifcReviewersService.reviewersPayload(payload);
    this.ifcPayloadRecords.emit(payload);    
  }

  reviewComponentUIShowHideData(records: IFCGroupsDTO[]) {
    this.approvalsRecords = [...records];
    this.approvalsRecordsFiltered = [...records.filter(x => x.type?.toString().toLocaleLowerCase() != IFCSecretaryGroupName)];
    switch (this.reviewComponent) {
      case true: {
        this.getFullName();
        break;
      }
      case false: {
        break;
      }
      case undefined: {
        break;
      }
    }
  }

  async getFullName() {
    let userFullName: string;
    for (let user of this.approvalsRecords) {
      user.fullName = "";
      for (let userEmail of user.approverEmail.split(';')) {
        this.graph.getUserByEmail(userEmail).subscribe((data: UserDetails) => {
          userFullName = `${data.givenName} ${data.surname}`;
          if (userFullName != undefined)
            user.fullName += userFullName+"  ";
        })
      }
     
    }
  }

  getErrorTipForDueDate(controlName: string): any {
    switch (this.proposalStatus) {
      case STATUSPendingGovernance: {
        const control = this.coordianatorIFCForm?.controls[controlName];
        this.showErrorMsg(control);
        break;
      }
      case STATUSPendingIFCConcurrence: {
        const control = this.ifcSecretaryForm?.controls[controlName];
        this.showErrorMsg(control);
        break;
      }
    }
  }

  showErrorMsg(control: any) {
    if (control.hasError('required')) {
      return "Please select Due by Date!"
    }
    return ""
  }

  async searchGroupMember(value: string, groupName: string) {
    
    if (value) {
      let users = [...await this.dataservice.searchUser(value)];
      switch (groupName) {
        case 'ifcLegal': {
          this.ifcLegalDefaultMember = [];
          for (let user of users) {
            this.ifcLegalDefaultMember.push({
              defaultEmail: user?.mail,
              reviewerId: 1,
              type: 'IFC Legal'
            })
          }
          break;
        }
        case 'ifcControllers': {
          this.ifcControllersDefaultMember = [];
          for (let user of users) {
            this.ifcControllersDefaultMember.push({
              defaultEmail: user?.mail,
              reviewerId: 4,
              type: "IFC Comptrollers"
            })
          }
          break;
        }
        case 'ifcTax': {
          this.ifcTaxDefaultMember = [];
          for (let user of users) {
            this.ifcTaxDefaultMember.push({
              defaultEmail: user?.mail,
              reviewerId: 3,
              type: "IFC Tax"
            })
          }
          break;
        }
        case 'ifcTreasury': {
          this.ifcTreasuryDefaultMember = [];
          for (let user of users) {
            this.ifcTreasuryDefaultMember.push({
              defaultEmail: user?.mail,
              reviewerId: 2,
              type: "IFC Treasury"
            })
          }
          break;
        }
        case 'ifcGovernance': {
          this.ifcGovernanceDefaultMember = [];
          for (let user of users) {
            this.ifcGovernanceDefaultMember.push({
              defaultEmail: user?.mail,
              reviewerId: 5,
              type: "IFC Governance"
            })
          }
          break;
        }
        case 'ifcSecretary': {
          this.ifcSecretaryDefaultMember = [];
          for (let user of users) {
            this.ifcSecretaryDefaultMember.push({
              defaultEmail: user?.mail,
              reviewerId: 10,
              type: "IFC Secretary"
            })
          }
          break;
        }
      }
    }
  }

  onGroupMemberChange(event: any) {
    
    this.createPayload();
  }

  sendReminderEmail() {
    this.isReminderEmailTrigger.emit(true);
  }

  ngOnDestroy() {
    this.ifcReviewersService.reviewNsubmitStatus(undefined);
    this.ifcReviewersService.getIFCUpdateRecordsStatus(undefined);
    // Clear stale IFC reviewer payloads so next proposal starts fresh
    this.ifcReviewersService.reviewersPayload([]);

    // Reset all IFC forms to prevent stale comments carrying over
    this.ifcLegalForm?.reset();
    this.ifcControllersForm?.reset();
    this.ifcTaxForm?.reset();
    this.ifcTreasuryForm?.reset();
    this.ifcGovernanceForm?.reset();
    this.ifcSecretaryForm?.reset();
    this.coordianatorIFCForm?.reset();

    // Reset form model objects
    this.ifcLegalFormModel = { ifcLegal: '', legalComments: '', ifcLegalSwitch: false };
    this.ifcControllersFormModel = { ifcControllers: '', controllersComments: '', ifcControllersSwitch: false };
    this.ifcTaxFormModel = { ifcTax: '', taxComments: '', ifcTaxSwitch: false };
    this.ifcTreasuryFormModel = { ifcTreasury: '', treasuryComments: '', ifcTreasurySwitch: false };
    this.ifcGovernanceFormModel = { ifcGovernance: '', governanceComments: '', ifcGovernanceSwitch: false };

    // Properly unsubscribe
    if (this.confidentialStateSubscription) {
      this.confidentialStateSubscription.unsubscribe();
    }
  }

  private applyConfidentialGovernanceRule() {
  if (!this.isConfidentialProposal || !this.currentUserEmail) return;

  this.ifcGovernanceDefaultMember = [{
    defaultEmail: this.currentUserEmail,
    reviewerId: 5,
    type: 'IFC Governance'
  } as any];

  if (this.proposalStatus === STATUSPendingGovernance) {
    this.coordianatorIFCForm?.controls['ifcGovernance']?.setValue([this.currentUserEmail]);
    this.coordianatorIFCFormModel.ifcGovernance = [this.currentUserEmail];
    this.coordianatorIFCForm?.controls['ifcGovernance']?.disable({ emitEvent: false });
  } 
  else {
    this.ifcGovernanceForm?.controls['ifcGovernance']?.setValue(this.currentUserEmail);
    this.ifcGovernanceFormModel.ifcGovernance = this.currentUserEmail as any;
    this.ifcGovernanceForm?.controls['ifcGovernance']?.disable({ emitEvent: false });
  }
}
}
